<template>
  <v-card>
    <v-card-title>Performance Table</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <v-select
            label="Month"
            :items="months"
            item-text="text"
            item-value="value"
            v-model="selectedMonth"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            label="Year"
            :items="years"
            v-model="selectedYear"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" class="d-flex justify-end">
          <v-btn color="primary" @click="generatePerformance" :loading="loading"
            >Generate Performance</v-btn
          >
          <v-btn @click="fetchPerformanceData" :loading="loading" class="ml-2"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="performanceData"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="red" @click="deletePerformance(item)"
            ><v-icon>mdi-delete</v-icon></v-btn
          >
        </template>
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.month, item.year) }}
        </template>
        <template v-slot:item.gross_profit_margin="{ item }">
          {{ item.gross_profit_margin }}%
        </template>
        <template v-slot:item.operating_expense_margin="{ item }">
          {{ item.operating_expense_margin }}%
        </template>
        <template v-slot:item.net_income_margin="{ item }">
          <span
            :class="item.net_income_margin >= 0 ? 'green--text' : 'red--text'"
          >
            {{ item.net_income_margin }}%
          </span>
        </template>
        <template v-slot:item.income_in_figures="{ item }">
          {{ item.income_in_figures.toLocaleString() }}
        </template>
        <template v-slot:item.cash_in="{ item }">
          {{ item.cash_in.toLocaleString() }}
        </template>
        <template v-slot:item.cash_out="{ item }">
          {{ item.cash_out.toLocaleString() }}
        </template>
        <template v-slot:item.balance="{ item }">
          <span :class="item.balance >= 0 ? 'green--text' : 'red--text'">
            {{ item.balance.toLocaleString() }}
          </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      headers: [
        { text: "Action", value: "actions" },
        { text: "Date", value: "date", width: "150" },
        { text: "Gross Profit Margin", value: "gross_profit_margin" },
        { text: "Operating Expense Margin", value: "operating_expense_margin" },
        { text: "Net Income Margin", value: "net_income_margin" },
        { text: "Income in Figures", value: "income_in_figures" },
        { text: "Cash In", value: "cash_in" },
        { text: "Cash Out", value: "cash_out" },
        { text: "Balance", value: "balance" },
      ],
      performanceData: [],
      selectedMonth: new Date().getMonth() + 1, // Current month
      selectedYear: new Date().getFullYear(), // Current year
      months: [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
      ],
      years: [
        { text: "2023", value: 2023 },
        { text: "2024", value: 2024 },
        { text: "2025", value: 2025 },
      ],
    };
  },
  created() {
    this.fetchPerformanceData();
  },
  methods: {
    formatDate(month, year) {
      return (
        moment()
          .month(month - 1)
          .format("MMMM") +
        ", " +
        year
      );
    },
    async fetchPerformanceData() {
      this.loading = true;
      axios
        .get("/performances")
        .then((response) => {
          this.performanceData = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error(
            "There was an error fetching the performance data!",
            error
          );
          this.loading = false;
        });
    },
    async deletePerformance(item) {
      let x = window.confirm("Are you sure you want to delete this item?");
      if (!x) return;
      this.loading = true;
      try {
        await axios.delete(`/performance/${item.id}`);
        this.performanceData = this.performanceData.filter(
          (data) => data.id !== item.id
        );
        alert("Performance record deleted successfully!");
        this.loading = false;
      } catch (error) {
        console.error("Error deleting performance record:", error);
        alert("Failed to delete performance record.");
        this.loading = false;
      }
    },
    async generatePerformance() {
      this.loading = true;
      let x = window.confirm(
        "Are you sure you want to generate performance for this month?"
      );
      if (!x) return;
      const month = this.selectedMonth;
      const year = this.selectedYear;

      axios
        .post("/performance", { month, year })
        .then((response) => {
          this.performanceData.push(response.data);
          console.log("Performance generated successfully:", response.data);
        })
        .catch((error) => {
          console.error(
            "There was an error generating the performance!",
            error
          );
        });

      this.loading = false;
    },
  },
};
</script>

<style></style>
